"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Button, Text, Modal, MarkdownRenderer } from "@nxt-costco-com/forge-components";
import { Checkmark } from "@nxt-costco-com/forge-icons/icons/Checkmark";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { COMPONENT_NAME } from "./constants.js";
import { buttonStyle, checkmarkStyle, headerStyle } from "./styles.js";
const FSAEligibleInfoUI = ({ data }) => {
  var _a, _b;
  const [isFSAModalOpen, setIsFSAModalOpen] = useState(false);
  const { key_value, composable_window } = data;
  const keyValue = key_value.reduce(
    (_keyValue, { key, value }) => {
      _keyValue[key] = value;
      return _keyValue;
    },
    {}
  );
  const modalTitle = keyValue == null ? void 0 : keyValue.titlecontent;
  const modalContent = (_b = (_a = composable_window == null ? void 0 : composable_window[0]) == null ? void 0 : _a.text_only) == null ? void 0 : _b.body;
  const buttonText = keyValue == null ? void 0 : keyValue.primarybuttonlabel;
  if (!modalTitle || !modalContent || !buttonText) return null;
  const handleFSAButtonClick = () => {
    setIsFSAModalOpen(true);
  };
  const handleFSAModalClose = () => {
    setIsFSAModalOpen(false);
  };
  return /* @__PURE__ */ jsxs(CostcoBox, { "data-testid": COMPONENT_NAME, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        onClick: handleFSAButtonClick,
        startIcon: /* @__PURE__ */ jsx(Checkmark, { sx: checkmarkStyle }),
        sx: buttonStyle,
        variant: "text-button",
        children: /* @__PURE__ */ jsx(Text, { variant: "t6", children: modalTitle })
      }
    ),
    /* @__PURE__ */ jsx(
      Modal,
      {
        buttons: [
          { action: handleFSAModalClose, text: `${buttonText}` }
        ],
        isOpen: isFSAModalOpen,
        modalTitle,
        onClose: handleFSAModalClose,
        children: /* @__PURE__ */ jsx(Text, { variant: "t6", children: /* @__PURE__ */ jsx(
          MarkdownRenderer,
          {
            overrides: {
              h3: {
                component: Text,
                props: {
                  component: "h3",
                  sx: headerStyle
                }
              },
              p: {
                component: Text,
                props: {
                  component: "p"
                }
              }
            },
            markdown: modalContent
          }
        ) })
      }
    )
  ] });
};
FSAEligibleInfoUI.displayName = COMPONENT_NAME;
export {
  FSAEligibleInfoUI
};
